import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './PagePreview.css';
import { api, contentPageUploadDir } from '../../config'

class PagePreview extends React.Component {
    static propTypes = {
        title: PropTypes.string.isRequired
    }

    render() {
        const { title, data } = this.props;

        return (
            <div className={s.container}>
                {data && data.getContentPage && data.getContentPage.pageBanner && (
                    <div
                        className={s.backGroungImg}
                        style={{ backgroundImage: `url(${api.apiEndpoint + contentPageUploadDir + data.getContentPage.pageBanner})` }}
                    />
                )}
                <div className={s.article}>
                    <h1 className={s.articleTitle}>{title}</h1>
                    <div
                        className={`ql-editor frontend ${s.content}`}
                        dangerouslySetInnerHTML={{ __html: data.getContentPage.content }}
                    />
                </div>
            </div>
        )
    }
}

export default withStyles(s)(PagePreview);